module.exports = __webpack_public_path__ + "media/abk/assets/images/surveys/form/copy_icon-904a241a7cac13f1ebb7c7bee4e6158e.svg";